import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export const useGetTaskPeriodicity = (taskTemplateId) => {
    const intl = useIntl();
    const { data, isLoading, error, refetch } = useQuery([TaskQueryKey.TaskPeriodicity, taskTemplateId], () => taskTemplateId
        ? api.base
            .get(`${config.appUrls.tasks}/api/TaskPeriodicity/${taskTemplateId}`)
            .then(res => res.data)
        : null, {
        enabled: true,
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return {
        data,
        error,
        isLoading,
        refetch,
    };
};
